import React from 'react';
import { InputField } from '../../../../components/controls/InputField';
import ButtonControl from '../../../../components/controls/ButtonControl';
import '../../../../styles/rsuite_override.css';
import { SelectListControl } from '../../../../components/controls';
import UserOrgTreeControl from '../../../../components/controls/UserOrgTreeControl';

export default function CertificationAdminFilters({ certificationAdminMgr, onFilterChange, orgMgr, orgs }) {

    const handleOnChange = (value, fieldName,) => {
        if (onFilterChange)
            onFilterChange(fieldName, value);
    }
    const handleClearFilter = () => {
        localStorage.setItem("CurrentPage", 1);
        certificationAdminMgr.filterData({ groups: [], orgs: null, districts: null, schools: null, users: null, candidate: null, status: null, IsActive: 'UNK' });
    }
    const onTreeCleanOrg = () => {
        handleOnChange([], "groups");
    }
    const onTreeSelect = (vals, field) => {
        //I actually filter by the user. because those users will be associated with the org/dis/school :)
        let newTreeIds = orgMgr?.findSelected(vals);
        if (handleOnChange)
            handleOnChange(newTreeIds, field);
    }
    return (
        <>
            <aside className="d-flex justify-content-center contentFilter" aria-label="Filter school administrator evaluator certifications">
                <div>
                    <h1 className="filterTitle">School Administrator Evaluator Certifications</h1>
                    <div className="filterControl">
                        <InputField
                            title='Find a Candidate'
                            value={certificationAdminMgr?.Filter?.candidate ?? ''}
                            fieldName='candidate'
                            disableError={true}
                            placeholder='Candidate'
                            onChange={handleOnChange}>
                        </InputField>
                    </div>
                    <div className="filterControl">
                        <InputField
                            title='Status'
                            value={certificationAdminMgr?.Filter?.status ?? 'UNK'}
                            fieldName='status'
                            disableError={true}
                            onChange={handleOnChange}>
                            <SelectListControl
                                textValuePairs={[{ Text: 'Not Started', Value: 0 },
                                { Text: 'In Progress', Value: 4 },
                                { Text: 'Passed', Value: 5 },
                                { Text: 'Failed', Value: 6 },
                                { Text: 'Manually Passed', Value: 8 }
                                ]} />
                        </InputField>
                    </div>
                    <div className="filterControl">
                        <InputField
                            id='groups'
                            title='Organization'
                            value={certificationAdminMgr?.Filter?.groups ?? []}
                            fieldName='groups'
                            disableError={true}
                            placeholder='Select'
                            onChange={handleOnChange}>
                            <UserOrgTreeControl
                                ariaLabel="Filter school administrator certifications by organization"
                                className={'filter-control-input'}
                                childrenKey="Children"
                                labelKey="Name"
                                valueKey="Id"
                                selectedValues={certificationAdminMgr?.Filter?.groups ?? []}
                                data={orgs ?? []}
                                menuClassName="org-tree-menu"
                                onClean={onTreeCleanOrg}
                                onSelect={(a, v) => onTreeSelect(v, 'groups')}
                                placement="autoHorizontalStart"
                            />
                        </InputField>
                    </div>

                    <div className="filterControl btn-clear">
                        <ButtonControl
                            onClick={handleClearFilter}
                            type="cancel">
                            Clear
                        </ButtonControl>
                    </div>
                </div>
            </aside>
        </>
    );
}